import React from "react";
import AssetsSafetyCheckModal from "./AssetsSafetyCheckModal";
import moment from "moment";
import { t } from "../../../../../utils/i18n";

const TradeActions = ({
  isBuyer,
  tradeData,
  offer,
  isSeller,
  isDisputed,
  isPaidClicked,
  acceptSuccess,
  paidTrade,
  readyToAccept,
  setReadyToAccept,
  validationMessageAccept,
  handleReleaseButtonClick,
  handleAssetsSafetyCheckConfirm,
  isAcceptClicked,
  isSystemCancelled,
  isCancelClicked,
  validationMessageDispute,
  setValidationMessageDispute,
  isDisputeClicked,
  isDisputedAllowed,
  showModal,
  showDisputeModal,
  isRotating,
  handleRefresh,
}) => {
  const token =
    tradeData?.crypto_currency_code == "USDT"
      ? "USD"
      : tradeData?.crypto_currency_code;
  return (
    <div className="tradeaction-parent-cont">

      {/* tradeaction-title */}
      <div className="tradedetails-tradeinfo-title tradeaction-title-section">
        <div>
          {isBuyer && tradeData.external_status === "pending_payment" && (
            <p>
              <i className="fas fa-exclamation-triangle"></i>{" "}
              {t("p2p.actions.make_payment", { amount: tradeData?.fiat, currency: tradeData?.fiat_currency_code, method: offer?.paymentMethod?.name })}
            </p>
          )}
          {isBuyer && tradeData.external_status === "payment_paid" && (
            <p>
              <i className="fas fa-exclamation-triangle"></i> {" "}
              {t("p2p.actions.made_payment", { amount: tradeData?.fiat, currency: tradeData?.fiat_currency_code, method: offer?.paymentMethod?.name })}
            </p>
          )}
          {isSeller && 
          (tradeData.external_status === "pending_payment" || tradeData.external_status === "payment_paid") && (
            <p>
              <i className="fas fa-exclamation-triangle"></i> {" "}
              {t("p2p.actions.selling", { amount: parseFloat(tradeData?.crypto_amount).toFixed(2), token, method: offer?.paymentMethod?.name })}
            </p>
          )}
        </div>
        <div>
          <span className="tradedetails-refresh-btn" title={t("p2p.actions.refresh_tip")} onClick={handleRefresh}>
            <i
              className={`fa fa-refresh ${
                isRotating ? "rotate" : ""
              }`}
              id="refreshBtn"
            ></i>
            {" "}
            {t("p2p.actions.refresh")}
          </span>
        </div>
      </div>
    
      <div>
        {/* Trade Action Status */}
        <div className="tradeaction-status">
          {isBuyer ? (
            <p>
              <i className="fas fa-bullhorn"></i>
              <br/>
              {t("p2p.actions.added", { amount: parseFloat(tradeData?.crypto_amount).toFixed(2), token })}
              <span style={{color: '#f79335'}}><b>{" "} {t("p2p.actions.warning")}</b> {t("p2p.actions.warning_text")}</span>
            </p>
          ) : (
            <></>
          )}
          {isBuyer && tradeData?.external_status === "payment_paid" ? (
            <p className="validationMessageDispute">
              <i className="fas fa-bullhorn"></i>
              <br/>
              {t("p2p.actions.you_paid")}
            </p>
          ) : (
            <></>
          )}
          {isSeller &&
          isSeller !== null &&
          tradeData.external_status === "pending_payment" ? (
            <p>
              <i className="fas fa-bullhorn"></i>
              <br/>
              {t("p2p.actions.not_paid")}
            </p>
          ) : (
            <></>
          )}
          {isSeller &&
          isSeller !== null &&
          tradeData.external_status === "payment_paid" &&
          acceptSuccess ? (
            <p>
              <i className="fas fa-bullhorn"></i>
              <br/>
              {t("p2p.actions.accepted")}
            </p>
          ) : isSeller &&
            isSeller !== null &&
            tradeData.external_status === "payment_paid" ? (
            <p>
              <i className="fas fa-bullhorn"></i>
              <br/>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("p2p.actions.buyer_paid_html", { amount: tradeData?.fiat, currency: tradeData?.fiat_currency_code, method: offer?.paymentMethod?.name }),
                }}
              />
            </p>
          ) : (
            <></>
          )}
          {tradeData?.external_status === "payment_paid" &&
            !isDisputed &&
            !acceptSuccess ? (
            <div>
              {validationMessageDispute !== "" && (
                <p className="validationMessageDispute">
                  <i className="fas fa-bullhorn"></i>
                  <br/>
                  {validationMessageDispute}
                </p>
              )}
            </div>
          ) : null}
          {isSeller && !acceptSuccess ? (
            <div>
              {validationMessageAccept !== "" && (
                <p  className="validationMessageDispute">
                  <i className="fas fa-bullhorn"></i>
                  <br/>
                  {validationMessageAccept}
                </p>
              )}
            </div>
          ) : null}
        </div>
  
        {/* Instructions */}
        <div className="tradedetails-instructions-from">
          {isBuyer &&
            tradeData.external_status === "pending_payment" && (
              <p>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("p2p.actions.buyer_note_html", { token }),
                  }}
                />
              </p>
            )}
          {isBuyer && tradeData.external_status === "payment_paid" && (
            <p>
              {t("p2p.actions.dispute_note")}
            </p>
          )}
          {isSeller &&
            isSeller !== null &&
            tradeData.external_status === "pending_payment" && (
              <p>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("p2p.actions.seller_note_html", { token, method: offer?.paymentMethod?.name }),
                  }}
                />
              </p>
            )}
        </div>
        
        {/* Action Notification and cta */}
        <div className="tradeaction-notification-cta">
          {/* MADE PAYMENT BUYER / RELEASE USD ACTIONS SELLER */}
          <div className="tradeaction-notification-cta-subsection">
            <div className="buyers-buttons-section">
              {tradeData?.external_status === "pending_payment" &&
              !isSystemCancelled ? (
                <div>
                  {isBuyer &&
                    tradeData?.external_status === "pending_payment" &&
                    !isSystemCancelled && (
                      <div>
                        <button
                          className="tradeaction-canceltradebtn"
                          type="button"
                          disabled={isCancelClicked}
                          onClick={(e) => showModal()}
                          title={t("p2p.actions.not_paid_tip")}
                        >
                          {isCancelClicked ? t("p2p.actions.please_wait_dots") : t("p2p.actions.cancel_trade")}
                        </button>
                      </div>
                    )}
                </div>
              ) : (
                <></>
              )}
              {isBuyer &&
              tradeData?.external_status !== "payment_paid" &&
              !isDisputed ? (
                <button
                  className="tradeaction-paidbtn"
                  disabled={isPaidClicked}
                  type="button"
                  onClick={(e) => paidTrade()}
                >
                  {isPaidClicked ? t("p2p.actions.please_wait") : t("p2p.actions.made_payment_btn")}
                </button>
              ) : (
                <></>
              )}{" "}
            </div>
            {isSeller && !acceptSuccess ? (
              <>
                <div className="tradeaction-checkboxarea-andvalidation-cont">
                  <div className="custom-control custom-checkbox tradeaction-checkboxarea ">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="readyToAccept"
                      checked={readyToAccept}
                      onChange={(e) => {
                        setReadyToAccept(e.target.checked);
                      }}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="readyToAccept"
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("p2p.actions.ready_html", { amount: parseFloat(tradeData?.crypto_amount).toFixed(2), fiat: tradeData?.fiat, currency: tradeData?.fiat_currency_code }),
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="sellerReleaseDisputeBtn-cont">
                <button
                  className="tradeaction-paidbtn"
                  disabled={
                    !(
                      tradeData?.external_status === "payment_paid" &&
                      readyToAccept
                    )
                  }
                  type="button"
                  onClick={(e) => handleReleaseButtonClick()}
                >
                  {isAcceptClicked
                    ? t("p2p.actions.please_wait")
                    : t("p2p.actions.release", { token })
                  }
                </button>
                {tradeData?.external_status === "payment_paid" &&
                !isDisputed &&
                !acceptSuccess ? (
                  <button
                  className="tradeaction-disputebtn pull-right"
                  type="button"
                  disabled={isDisputeClicked}
                  onClick={(e) => showDisputeModal()}
                  title={t("p2p.actions.no_payment_tip")}
                >
                  {isDisputeClicked ? t("p2p.actions.please_wait_dots") : t("p2p.actions.dispute")}
                </button>
                 ) : (
                  <></>
                )}
                </div>
              </>
            ) : (
              <></>
            )}
            
          </div>
        </div>
        {/* NOT DISPUTED RELATED ACTIONS */}
        <div className="tradeaction-notification-cta">
          <div className="tradeaction-notification-cta-subsection">
            {tradeData?.external_status === "payment_paid" &&
            !isDisputed &&
            !acceptSuccess ? (
            <div className="buyers-buttons-section ">
              {/* For buyer only. Display cancel button when buyer has clicked paid */}
              {isBuyer && !isDisputed ?  (
                <div>
                  <button
                    className="tradeaction-canceltradebtn"
                    type="button"
                    disabled={isCancelClicked}
                    onClick={(e) => showModal()}
                    title={t("p2p.actions.changed_mind")}
                  >
                  {isCancelClicked ? t("p2p.actions.please_wait_dots") : t("p2p.actions.cancel_trade")}
                  </button>
                </div>
              ) : (<></>)
              }
              {isBuyer && !isDisputed ?  (
              <div>
                <button
                  className="tradeaction-disputebtn"
                  type="button"
                  disabled={isDisputeClicked}
                  onClick={(e) => showDisputeModal()}
                  title={t("p2p.actions.no_payment_tip")}
                >
                  {isDisputeClicked ? t("p2p.actions.please_wait_dots") : t("p2p.actions.dispute")}
                </button>
              </div>
              ) : (<></>)
             }
            </div>
            ) : (
              <></>
            )}
          </div>
        </div>

        {/* DISPUTED RELATED ACTIONS */}
        <div className="tradeaction-notification-cta">
          <div className="tradeaction-notification-cta-subsection">
            {tradeData?.external_status === "payment_paid" &&
            isDisputed &&
            !acceptSuccess ? (
            
            <div className="buyers-buttons-section ">
              {/* For buyer only. Display cancel button when buyer has clicked paid */}
              {isBuyer && isDisputed ?  (
                <div>
                  <button
                    className="tradeaction-canceltradebtn"
                    type="button"
                    disabled={isCancelClicked}
                    onClick={(e) => showModal()}
                    title={t("p2p.actions.changed_mind")}
                  >
                  {isCancelClicked ? t("p2p.actions.please_wait_dots") : t("p2p.actions.cancel_trade")}
                  </button>
                </div>
              ) : (<></>)
              }
            </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="tradedetails-disclaimer-info">
        {isBuyer ? (
          <p>
            <i className="fas fa-exclamation-triangle"></i>
            {" "}
            {t("p2p.actions.keep_inside")}
          </p>
        ) : (
          <p>
            <i className="fas fa-exclamation-triangle"></i>
            {" "}
            <span
              dangerouslySetInnerHTML={{
                __html: t("p2p.actions.dishonest_html"),
              }}
            />
          </p>
        )}
      </div>
    </div>
  )
}

export default TradeActions;
